export const scheduleTimeForFirstStep = [
  { label: 'After 10 Mins', value: 10 },
  { label: 'After 60 Mins', value: 60 },
  { label: 'After 3 Hrs', value: 180 },
  { label: 'After 6 Hrs', value: 360 },
  { label: 'After 12 Hrs', value: 720 },
  { label: 'After 1 Day', value: 1440 },
  { label: 'After 2 Days', value: 2880 },
];

export const scheduleTime = [
  { label: 'After 1 Day', value: 1440 },
  { label: 'After 2 Days', value: 2880 },
  { label: 'After 3 Days', value: 4320 },
  { label: 'After 4 Days', value: 5760 },
  { label: 'After 5 Days', value: 7200 },
  { label: 'After 6 Days', value: 8640 },
  { label: 'After 7 Days', value: 10080 },
  { label: 'After 8 Days', value: 11520 },
  { label: 'After 9 Days', value: 12960 },
  { label: 'After 10 Days', value: 14400 },
  { label: 'After 20 Days', value: 28800 },
  { label: 'After 1 Month', value: 43200 },
];

export const immediateDelay = [{ label: 'Immediately', value: 5 }];
